import rootReducer from "./rootReducer";
import { configureStore } from "@reduxjs/toolkit";
import persistReducer from "redux-persist/es/persistReducer";
import persistStore from "redux-persist/es/persistStore";
import storage from "redux-persist/lib/storage";
import { createMigrate } from "redux-persist";

const middlewares = [];

// 🔹 Increment this whenever you change any slice schema
const CURRENT_VERSION = 17;

// const migrations = {
//   4: (state) => {
//     // Safely add missing keys or defaults
//     return {
//       ...state,
//       auth: {
//         ...state.auth,
//         token: null,
//       },
//       orders: {
//         ...state.orders,
//         cateringApiToken: state.orders?.cateringApiToken || {
//           token: null,
//           expiresAt: 0,
//         },
//         kitchens: Array.isArray(state.orders?.kitchens)
//           ? state.orders.kitchens
//           : [],
//         isKitchenRadioGroupSelected:
//           typeof state.orders?.isKitchenRadioGroupSelected === "boolean"
//             ? state.orders.isKitchenRadioGroupSelected
//             : false,
//       },
//     };
//   },
// };

const migrations = {
  [CURRENT_VERSION]: () => undefined, // this clears state when migrating TO version 2
};

const persistConfig = {
  key: "root",
  storage,
  version: CURRENT_VERSION,
  whitelist: [
    "airport",
    "auth",
    "customers",
    "history",
    "invoice",
    "menu",
    "orders",
    "roles",
    "user",
    "theme",
  ],
  migrate: createMigrate(migrations, { debug: false }),
};

const persistedReducer = persistReducer(persistConfig, rootReducer());

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(middlewares),
  devTools: process.env.NODE_ENV === "development",
});

store.asyncReducers = {};

export const injectReducer = (key, reducer) => {
  if (store.asyncReducers[key]) {
    return false;
  }
  store.asyncReducers[key] = reducer;
  store.replaceReducer(rootReducer(store.asyncReducers));
  return store;
};

export default store;
export const persistor = persistStore(store);
